import Box from '@mui/material/Box';
import {
    Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer,
    TableRow, Typography, useMediaQuery
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import CloseIcon from '@mui/icons-material/Close';
import { TempPartnerSignup } from '../../../app/models/partners';
import { adminUserStyles } from '../adminUsers/adminUserStyles';

interface Props {
    partnerData: TempPartnerSignup;
}
const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#B6DAFF',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
    })
};

const AdminPartnerTempModal = ({ partnerData }: Props) => {

    const { modalStore } = useStore();
    const { closeModal } = modalStore;

    const matches = useMediaQuery('(min-width:900px)');

    const closeModalHandler = () => {
        closeModal();
    }
    if (!partnerData)
        return null;
    return (
        <Box sx={style(matches)}>
            <Typography variant='h6' textAlign='center'>{partnerData.username}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table" >
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Username: {partnerData.username}
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Email:  {partnerData.emailId}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                <TableRow sx={{ bgcolor: '#478ac92e' }}>
                                    <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                        Roles: {partnerData.roles}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        pt={2}
                    >
                        <Button size={matches ? "medium" : "small"} variant="contained" onClick={closeModalHandler}
                            startIcon={<CloseIcon />}>Close</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}
export default observer(AdminPartnerTempModal);